<template>
  <div>
    <Breadcrumb v-if="!hasHero" :links="links"></Breadcrumb>
    <Teleport v-else to=".s-hero">
      <Breadcrumb class="s-breadcrumb__abs-image" :links="links"></Breadcrumb>
    </Teleport>
  </div>
</template>

<script setup>
import jQuery from 'jquery'
import { ref } from 'vue'
import { getData } from '../../lib/lib'
import Breadcrumb from '../components/Breadcrumb.vue'

const { links } = getData('breadcrumbData')

const hero = jQuery('.s-hero')

const hasHero = ref(hero.length && !hero.hasClass('s-hero--no-data'))
</script>
